import En_Code from './locales/en.json'
import Zh_CnCode from './locales/zh-CN.json'

export const selectedLanguageCode = {
  'en': En_Code,
  'zh-CN': Zh_CnCode,
}

export default {}
